import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { OrderSummary } from './OrderSummary';

export class RecentOrdersPaginated {
  @Type(() => OrderSummary)
  items: OrderSummary[];

  @Expose({ name: 'next_page_url' })
  nextPageUrl?: string;

  constructor(items: OrderSummary[], nextPageUrl?: string) {
    this.items = items;
    this.nextPageUrl = nextPageUrl;
  }

  get cursor(): string | null {
    return this.nextPageUrl == null
      ? null
      : new URLSearchParams(new URL(this.nextPageUrl).search).get('cursor');
  }

  static fromJson(json: Record<string, any>): RecentOrdersPaginated {
    return plainToInstance(RecentOrdersPaginated, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
